<div class="top-section">
    <div class="big-text">
        <div class="social-top">
            <ul class="list-social">
                <li class="icon-soc tipped" data-title="twitter"
                    data-tipper-options="{&quot;direction&quot;:&quot;top&quot;,&quot;follow&quot;:&quot;true&quot;}">
                    <a href="https://twitter.com/Vidhema1" class="twitter" target="_blank"></a>
                </li>
                <li class="icon-soc tipped" data-title="facebook"
                    data-tipper-options="{&quot;direction&quot;:&quot;top&quot;,&quot;follow&quot;:&quot;true&quot;}">
                    <a href="https://www.facebook.com/pages/category/Computer-Company/Vidhema-Solutions-125764551621381/"
                        class="facebook" target="_blank"></a>
                </li>
                <li class="icon-soc tipped" data-title="github"
                    data-tipper-options="{&quot;direction&quot;:&quot;top&quot;,&quot;follow&quot;:&quot;true&quot;}">
                    <a href="https://www.instagram.com/vidhema.technologies.pte.ltd/?hl=en" class="insta"
                        target="_blank"></a>
                </li>
                <li class="icon-soc tipped" data-title="google +"
                    data-tipper-options="{&quot;direction&quot;:&quot;top&quot;,&quot;follow&quot;:&quot;true&quot;}">
                    <a href="https://www.linkedin.com/company/vidhema-solutions?originalSubdomain=in" class="linkedin"
                        target="_blank"></a>
                </li>
            </ul>
        </div>

        <section class="wrapper">

            <div class="container">
                <h2 class="sentence">Embrace the Nonpareil Team of
                    <span class="verticalFlip">
                        <span>Web Development</span>
                        <span>Web Designers</span>
                        <span>NFT Development</span>
                        <span>Web 3.0</span>
                        <span>Blockchain</span>
                    </span>
                </h2>
    
                <div class="hero-para">
                    <p>Enable businesses to be <span>futuristic</span>, and <span>high-performing</span> by providing
                        full-cycle solutions</p>
                </div>
            </div>


        </section>
    </div>

    <video id="video_background" preload="auto" autoplay="true" loop="loop" muted="muted" volume="0" width="100%" height="600"
        poster="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913165440-240home-page.jpg">
      
    </video>
</div>
<section class="mt-n5 z-index-9 position-relative our-slient-section brand-logo-mobile">
    <div class="container carousel-box">
        <div class="our-client">
            <h5>Our Clients</h5>
        </div>
        <div class="owl-carousel owl-theme owl-loaded owl-drag our-client-wrapper" id="client-slider">

                    <div class="item">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202296165918-952love-bonito.png" alt="Love Bonito" loading="lazy" />
                    </div>
                    <div class="item ramybrook">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/20229617449-343ramybrook.png" alt="ramybrook" loading="lazy" title="ramybrook">
                    </div>
                    <div class="item">
                            <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/about/sp-commerce.webp" class="spcomlogo" alt="sp-commerce" loading="lazy">
                    </div>
                    <!-- <div class="item">
                            <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/client-logo/bodyshop-logo.svg" alt="The Body Shop" loading="lazy">
                    </div> -->
                    <div class="item">
                            <img class="small-client-logos" src="https://vidhema-website.s3.amazonaws.com/home-new/image/client-logo/vans.svg" alt="Vans" loading="lazy">
                    </div>
                    <div class="item">
                            <img class="small-client-logos" src="https://vidhema-website.s3.amazonaws.com/home-new/image/client-logo/handm.svg" alt="H&M" loading="lazy">
                    </div>
                    <div class="item">
                        <img class="small-client-logos" src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202291318425-161ada-digital-logo.jpg" alt=" ADA Digital " loading="lazy">
                    </div>
                    <div class="item">
                            <img class="medium-client-logos" src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202291319339-702lockwood-logo-jpg.jpg" loading="lazy" alt="Lockwood" loading="lazy">
                    </div>
                    <div class="item">
                            <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/about/stc.webp" loading="lazy" alt="STC" loading="lazy">
                    </div>
                    <div class="item">
                            <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/client-logo/ilastword.webp" loading="lazy" alt="ilastword" loading="lazy">
                    </div>
                    
            
        </div>
    </div>
</section>
<section class="brands-logo-section-vid brand-logo-desktop">
    <div class="container-fluid">
        <div class="row-logos">
            <div class="main-logo-brand-div">
                <div>
                    <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202296165918-952love-bonito.png" alt="Love Bonito">
                </div>
            </div>
            <div class="main-logo-brand-div">
                <div>
                    <img class="small-logo-brand" src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/20229617449-343ramybrook.png" alt="Ramybrook" title="ramybrook">
                </div>
            </div>
            <div class="main-logo-brand-div">
                <div>
                    <img class="small-logo-brand" src="https://vidhema-website.s3.amazonaws.com/home-new/image/about/sp-commerce.webp" alt="SP Commerce">
                </div>
            </div>
            <!-- <div class="main-logo-brand-div">
                <div>
                    <img class="small-logo-brand" src="https://vidhema-website.s3.amazonaws.com/home-new/image/client-logo/bodyshop-logo.svg" alt="The Body Shop">
                </div>
            </div> -->
            <div class="main-logo-brand-div">
                <div>
                    <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/client-logo/vans.svg" alt="Vans">
                </div>
            </div>
            <div class="main-logo-brand-div">
                <div>
                    <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/client-logo/handm.svg" alt="H&M">
                </div>
            </div>
            <div class="main-logo-brand-div">
                <div>
                    <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202291318425-161ada-digital-logo.jpg" alt="ADA Logo">
                </div>
            </div>
            <div class="main-logo-brand-div">
                <div>
                    <img class="small-logo-brand" src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/20221010101441-361lockwood.png" alt="Lockwood" title="lockwood">
                </div>
            </div>
            <div class="main-logo-brand-div">
                <div>
                    <img class="small-logo-brand" src="https://vidhema-website.s3.amazonaws.com/home-new/image/about/stc.webp" alt="STC">
                </div>
            </div>
            <div class="main-logo-brand-div">
                <div>
                    <img class="small-logo-brand" src="https://vidhema-website.s3.amazonaws.com/home-new/image/client-logo/ilastword.webp" alt="ilastword">
                </div>
            </div>
        </div>
    </div>
</section>
<div class="section about-us main-about-us">
    <div class="container">
        <div class="header-text">
            <div class="header-shadow-text">Web & Mobile App</div>
            <h1>Top-Notch Web and Mobile App Development Services</h1>
            <p>We are always at your assistance</p>
        </div>
        
        <div class="row multi-info">
            <div class="col-lg-3 col-md-6 mb-4 ">
                <div class="border bg-white border-radius p-5 p-md-4 h-100 project-number-text aboutus-hover">
                    <span class="display-4 text-primary mb-3 d-block"></span>
                    <h4 class="">Projects carried out an ACTION to the HALT</h4>
                </div>
            </div>
            <div class="col-lg-5 col-md-6 mb-4 about-us-video">
                <div class="h-100 bg-overlay-black-60 bg-holder border-radius p-3 position-relative d-flex align-items-center commondivclassmulti"
                    style="background-image: linear-gradient(to bottom, black, transparent), url(https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022817182128-138about-us-section.jpg);background-size: cover;">
                    <div class="position-relative text-center">
                        <h5 class="mb-0 text-white rating-text">Delegating seamless user experiences across all
                            modern platforms &amp; devices</h5>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-4">
                <div class="bg-theme border-radius p-5 p-md-4 h-100 commondivclassmulti">
                    <div class="d-flex align-items-center">

                    </div>
                    <p class="text-white mt-3">When a company can rely on its employees is the best honor they could
                        get. An excellent work environment with good opportunities makes an employee work
                        efficiently. Combining all these factors is an inspiration that can boost their career. We
                        are thrilled and gratified for the people who work fervently with us to build a great
                        workplace!</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 mb-4 mb-lg-0">
                <div class="h-100 bg-overlay-black-60 bg-holder border-radius p-4 position-relative d-flex align-items-center commondivclassmulti"
                    style="background-image: url(https://vidhema-website.s3.amazonaws.com/home-new/image/7.webp);">
                    <div class="position-relative text-center">
                        <h5 class="mb-0 text-white rating-text">Rated as one of the leading IT companies globally.
                        </h5>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 mb-4 mb-md-0 ">
                <div class="border h-100 text-center p-3 bg-white aboutus-hover commondivclassmulti">
                    <h5 class="mb-1 award-win-sol">Internationally Recognized Offerings</h5>
                    <img class="img-fluid" src="https://vidhema-website.s3.amazonaws.com/home-new/image/award.svg" alt="Recognized Awards" loading="lazy">
                    <p>We’ve accomplished a few awards for our services, thanks to our awesome clientele.</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-4 mb-4 mb-md-0">
                <div class="h-100 bg-theme text-center p-5 p-md-4 border-radius clients-globle commondivclassmulti">
                    <span class="display-4 text-white">150+</span>
                    <h5 class="text-white">Clients across the globe</h5>
                </div>
            </div>
            <div class="col-lg-3 col-md-4">
                <div class="border bg-white h-100 p-3 border-radius d-flex align-items-center aboutus-hover commondivclassmulti">

                    <p class="mt-3">Vidhema Technologies has a proven record of developing websites, applications,
                        and software. We are proud to be the top-most choice in the tech market for leading
                        enterprises and have offered our services to many clients around every corner of the world.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>
<section id="services">
    <div class="container">
        <div class="header-text">
            <div class="header-shadow-text">SERVICES</div>
            <h2>SERVICES</h2>
            <p>JUST CHECK OUT ALL OF THE SERVICE LISTS BELOW TO GET A GENERAL IDEA OF WHAT WE ARE CAPABLE OF
                DELIVERING.</p>
        </div>
    </div>
    <div class="service-tab-section">
        <div class="row">

            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH web3-0-icon"></div>
                    <h5>Web 3.0</h5>
                    <ul class="list">
                        <li>
                            <a tabindex="-1" href="/technologies-mobile-ios.html">NFT</a>
                        </li>
                        <li>
                            <a tabindex="-1" href="/technologies-mobile-android.html">Blockchain</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>Get NFT Development to experience the Metaverse, Blockchain services to record the
                        transactions and track assets, and Web 3.0 to experience the next-gen of the internet().</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH mobileIcon">  </div>
                    <h5>Mobile &amp; Wearables</h5>
                    <ul class="list">
                        <li>
                            <a tabindex="-1" href="/technologies-mobile-ios.html">iOS</a>
                        </li>
                        <li>
                            <a tabindex="-1" href="/technologies-mobile-android.html">Android</a>
                        </li>
                        <li>
                            <a href="/technologies-mobile-phonegap.html">Phonegap</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We offer an affordable mobile app development service for both android and iOS as well as
                        hybrid app development for different types of businesses.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH ecommerce-icon"></div>
                    <h5>Ecommerce Development</h5>
                    <ul class="list">
                        <li>
                            <a href="/technologies-ecommerce-magento.html">MAGENTO</a>
                        </li>
                        <li>
                            <a href="/technologies-cms-wordpress.html">WORDPRESS</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We can help you to create a user-friendly website so you can reach out to your potential
                        customers online and maximize the sales of your business.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH web-icon"></div>
                    <h5>Web Development</h5>
                    <ul class="list">
                        <li>
                            <a tabindex="-1" href="/technologies-web-php.html">PHP</a>
                        </li>
                        <li>
                            <a tabindex="-1" href="/technologies-web-dotnet.html">
                                <strong>.</strong>Net
                            </a>
                        </li>
                        <li>
                            <a tabindex="-1" href="/technologies-web-java.html">Java</a>
                        </li>
                        <li>
                            <a tabindex="-1" href="/technologies-web-rubyonrails.html">ROR</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We provide high-end and user-friendly web development services that help to create your ideas
                        into reality in front of a wide range of audiences.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH javascript-icon"></div>
                    <h5>Javascript</h5>
                    <ul class="list">
                        <li>
                            <a href="/technologies-javascript-angular-js.html">Angular </a>
                        </li>
                        <li>
                            <a href="/technologies-javascript-vue-js.html">Vue</a>
                        </li>
                        <li>
                            <a href="/technologies-javascript-react-js.html">React</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We have an excellent team of professionals for Javascript development that can help to build
                        cross-platform applications to succeed in your business.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH game-icon"></div>
                    <h5>Game</h5>
                    <ul class="list">
                        <li>
                            <a href="/technologies-Oculus-Rift-Game-Development.html">OCULUS RIFT </a>
                        </li>
                        <li>
                            <a href="/technologies-Virtual-Reality-Game-Development.html">VR </a>
                        </li>
                        <li>
                            <a href="/technologies-HTC-Vive-Game-Development.html">HTC VIVE</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We develop all kinds of games, with our latest technologies &amp; highly skilled developers
                        we tend to provide the best mobile game development services.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH offshore-icon"></div>
                    <h5>Offshore Staffing</h5>
                    <ul class="list">
                        <li>
                            <a tabindex="-1" href="/technologies-mobile-ios.html">iOS</a>
                        </li>
                        <li>
                            <a tabindex="-1" href="/technologies-mobile-android.html">Android</a>
                        </li>
                        <li>
                            <a tabindex="-1" href="/technologies-web-php.html">PHP</a>
                        </li>
                        <li>
                            <a tabindex="-1" href="/technologies-ecommerce-magento.html">Magento</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>Our offshore staffing services help you to find a trusted and best workforce for your
                        business.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH iot-icon"> </div>
                    <h5>IOT (Internet of Things)</h5>
                    <ul class="list">
                        <li>
                            <a>Consult</a>
                        </li>
                        <li>
                            <a>Develop</a>
                        </li>
                        <li>
                            <a>Implement</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>Our internet of things development services enables enterprises to maximize their return on
                        investment through our experienced IoT app consultant.</p>
                </div>
            </div>
        </div>
    </div>
</section>

 






















<div class="section about-us solution-partner">
    <div class="container">
        <div class="header-text">
            <div class="header-shadow-text">ADOBE SOLUTION PARTNER</div>
            <h2>ADOBE SOLUTION PARTNER</h2>
            <p>Let’s customize your website together with our expert Adobe Solutions!</p>
        </div>
        <div class="row adobe-section">
            <div class="col-md-7 adobe-detail">
                <p>With an excellent experience as a Bronze Solution Partner of Adobe products, Vidhema Technologies
                    focuses on delivering unparalleled solutions with Adobe Experience Cloud integrations &amp;
                    implementations. We ensure to offer compelling Adobe services to our clientele. As a certified
                    Adobe Partner Agency, the expertise that we dwell on is to empower &amp; boost your business.</p>


                <div class="adobe-product">
                    <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/Adobe-logo.png" alt="Adobe Solution Partner" loading="lazy">
                    <div class="solution-partner">
                        <h3>Adobe<span>Solution Partner</span></h3>
                        <ul>
                            <li>Adobe Experience Manager</li>
                            <li>Adobe Experience Cloud</li>
                            <li>Adobe Experience Manager Assets</li>
                            <li>Digital Asset Management (DAM)</li>
                            <li>Adobe Partner in Bronze Category</li>
                        </ul>
                    </div>
                </div>
                
                <a href="#" class="btn btn-theme explore-btn">ADOBE PARTNER CREDENTIALS</a>
            </div>
            <div class="col-md-5 adobe-image">
                <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022829193521-402adobe-solution-partner.jpg" class="w-100 adobe-partner-image"
                    alt="Adobe Solution Partner Banner" loading="lazy">
            </div>
        </div>
    </div>
</div>

<section class="nft-section-wrapper top">
    <div class="container">
        <div class="header-text">
            <div class="header-shadow-text">Offerings for Digital Era</div>
            <h2>Offerings for Digital Era</h2>
        </div>

        <h2>NFT Development</h2>
        <div class="row">
            <div class="col-md-6 nft-img">
                <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202281722557-208nft-development-home.jpg" loading="lazy" alt="Nft vector" loading="lazy">
            </div>
            <div class="col-md-6 nft-section-content">
                <div>
                    <blockquote>
                        <strong>Get NFT Development to experience the Metaverse; a platform that can be used to buy
                            &amp; sell digital assets</strong>
                        <ul role="list">
                            <li><i class="fa fa-check"></i>NFT Marketplace Platform</li>
                            <li><i class="fa fa-check"></i>NFT Ecommerce</li>
                            <li><i class="fa fa-check"></i>NFT Wallet</li>
                        </ul>
                    </blockquote>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="nft-section-wrapper middle ">
    <div class="container">
        <h2>Blockchain Development</h2>
        <div class="row">
            <div class="col-md-6 nft-section-content">
                <div>
                    <blockquote>
                        <strong>Blockchain is an immutable, shared ledger that enables you to record transactions
                            and track assets</strong>
                        <ul role="list">
                            <li><i class="fa fa-check"></i>Public Blockchain</li>
                            <li><i class="fa fa-check"></i>Private BLockchain</li>
                            <li><i class="fa fa-check"></i>Hybrid Blockchain</li>
                        </ul>
                    </blockquote>
                </div>
            </div>
            <div class="col-md-6 blockchain-img">
                <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022914143424-338blockchain-development.jpg" alt="Blockchain Development " loading="lazy">
            </div>
        </div>
    </div>
</section>

<section class="nft-section-wrapper bottom">
    <div class="container">
        <h2>Web 3.0</h2>
        <div class="row">
            <div class="col-md-6 web-img">
                <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/web-3.0.webp" loading="lazy" alt="Web 3.0 vector">
            </div>
            <div class="col-md-6 nft-section-content">
                <div>
                    <blockquote>
                        <strong>Web 3.0 is the next gen of the internet which allows websites and apps the ability
                            to process data</strong>
                        <ul role="list">
                            <li><i class="fa fa-check"></i>Artificial Intelligence (AI)</li>
                            <li><i class="fa fa-check"></i>3-D Graphics or Metaverse</li>
                            <li><i class="fa fa-check"></i>Semantic Web</li>
                        </ul>
                    </blockquote>
                </div>
            </div>
        </div>
    </div>
</section>


<section class="testi-title-section">
    <div class="container">
        <div class="header-text">
            <div class="header-shadow-text">Happy clients</div>
            <h2>Happy clients</h2>
            <p>Our happy clients have a lot to tell you</p>
        </div>
    </div>
</section>

<section class="testimonial-section">
    <div class="container testimonial-container">
        <div id="slider" class="owl-carousel owl-loaded owl-drag">
            <div class="content-area">
                <div class="content">
                    <div class="clients">
                        <h5>CreateApp Asia</h5>
                        <p><span>“</span>Excellent communication, vision and delivery., superb and dedicated team! Delivery is always on time.
                            <span>”</span></p>
                    </div>
                    <div class="img-area">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022825131927-901createapp.jpg" alt="Happy Client One" loading="lazy">
                    </div>
                    <div class="star-icon text-center">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <div class="quote">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913192922-475quote-small.png" alt="Double Quote" loading="lazy">
                    </div>
                </div>
            </div>
            <div class="content-area">
                <div class="content">
                    <div class="clients">
                        <h5>Micheal Rott</h5>
                        <p>“It was really great working with Vidhema Team, Whole project development was a smooth
                            run
                            and they delivered on time as well. I will surely work with them again. Wish you all the
                            best Vidhema Team.
                        </p>
                    </div>
                    <div class="img-area">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913183835-433Happy-Client-Image-two.jpg" alt="Happy Client Two" loading="lazy">
                    </div>
                    <div class="star-icon text-center">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <div class="quote">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913192922-475quote-small.png" alt="Double Quote" loading="lazy">
                    </div>
                </div>
            </div>
            <div class="content-area">
                <div class="content">
                    <div class="clients">
                        <h5>Emmanuel kibanga</h5>
                        <p>“The work experience with Vidhema Technologies has been phenomenal. Collaboration and communication with the company have been easy. The team was very receptive to ideas and changes and was very quick and hard working.”</p>
                    </div>
                    <div class="img-area">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022825132021-54340413-emmanuel.elieza.jpg" alt="Happy Client Three" loading="lazy">
                    </div>
                    <div class="star-icon text-center">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <div class="quote">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913192922-475quote-small.png" alt="Double Quote" loading="lazy">
                    </div>
                </div>
            </div>
            <div class="content-area">
                <div class="content">
                    <div class="clients">
                        <h5>Abeed Kapdi</h5>
                        <p>“The development team at Vidhema Technologies is extraordinary, they are alway on top of the task and keen to give suggestions to betterment of the project. ”</p>
                    </div>
                    <div class="img-area">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913182758-739Happy-Client-Image.jpg" alt="Happy Client Four" loading="lazy">
                    </div>
                    <div class="star-icon text-center">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <div class="quote">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913192922-475quote-small.png" alt="Double Quote" loading="lazy">
                    </div>
                </div>
            </div>
            <div class="content-area">
                <div class="content">
                    <div class="clients">
                        <h5>Loril Den</h5>
                        <p>“Before working with Vidhema Technologies we weren’t getting the desired results. Thanks
                            to
                            vidhema team to make it happen for us.”</p>
                    </div>
                    <div class="img-area">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022817175458-644client-5.jpg" alt="Happy Client Five" loading="lazy">
                    </div>
                    <div class="star-icon text-center">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <div class="quote">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913192922-475quote-small.png" alt="Double Quote" loading="lazy">
                    </div>
                </div>
            </div>
            <div class="content-area">
                <div class="content">
                    <div class="clients">
                        <h5>Henry Choo</h5>
                        <p><span>“</span>It's always a pleasure working with Vidhema Team, I have been associated
                            with them for more
                            than 1 year now and must say they are quite supportive & always good to deliver the
                            desired
                            outcome! I'll continue to work with them.<span>”</span></p>
                    </div>
                    <div class="img-area">
                        <img src="https://vidhema-website.s3.amazonaws.com/home-new/image/about/client-1.webp" alt="Happy Client One" loading="lazy">
                    </div>
                    <div class="star-icon text-center">
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                        <i class="fa fa-star" aria-hidden="true"></i>
                    </div>
                    <div class="quote">
                        <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913192922-475quote-small.png" alt="Double Quote" loading="lazy">
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>

<!-- testimonial section end -->
<!-- card-section -->

<!-- <div class="case-study-text">  </div> -->

<div class="sucess-box">

<h2 class="case-study-text">  Case Study</h2>


<section class="sucess-story py-3">
<div class="container">
    <div class="row">
        <div class="col-md-6 training transition">
            <div class="casestudy-single wow fadeInDown" data-wow-duration="1.5s" data-wow-delay="0.2s"
                    style="visibility: visible; animation-duration: 1.5s; animation-delay: 0.2s; animation-name: fadeInDown;">
                    <img src="../../../assets/images/slide11-3.jpg" class="casestudy1" alt="image">
                    <a class="read-more"  routerLink="/case-studies/ilastword.html"
                        href="/casestudy-details"><span class="btn-text">Read more</span><span class="btn-arrow"><i
                                class="fa fa-long-arrow-right"></i></span></a>

                    <div class="text"><span>social media platform</span>
                        <h3 class="card-heading"><a  routerLink="/case-studies/ilastword.html" href="/casestudy-details">  iLastword</a></h3>
                    </div>
                </div>
        </div>
        <div class="col-md-6 training transition">
            <div class="casestudy-single wow fadeInDown" data-wow-duration="1.5s" data-wow-delay="0.2s"
                    style="visibility: visible; animation-duration: 1.5s; animation-delay: 0.2s; animation-name: fadeInDown;">
                    <img src="../../../assets/images/Untitled-9.jpg" class="casestudy1" alt="image">
                    <a class="read-more"  routerLink="/case-studies/threndx.html"
                        href="/casestudy-details"><span class="btn-text">Read more</span><span class="btn-arrow"><i
                                class="fa fa-long-arrow-right"></i></span></a>

                    <div class="text"><span>social media platform</span>
                        <h3><a routerLink="/case-studies/threndx.html" href="/casestudy-details">Threndx
                        </a></h3>
                    </div>
                </div>
        </div>
    </div>
</div>
</section>

    
</div>










<section id="blog">
    <div class="just_pattern"></div>
    <div class="parallax1"></div>
    <div class="container z-index">
        <div class="header-text">
            <div class="header-shadow-text">Blog</div>
            <h2>Blog</h2>
        </div>
        <div class="row owl-carousel owl-loaded owl-drag" id="blog-slider">
            <div class="col-md-12">
                <div class="blog-post" routerLink="/blog/five-reasons-why-you-should-outsource-web-app-development">
                    <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202282919616-7775-why-you-should-outsource-vidhema.jpg" alt=" 5 Reasons Why You Should Outsource Web App Development" loading="lazy" />
                    <h5>5 Reasons Why You Should Outsource Web App Development</h5>
                    <p class="blog-description">If we look around for a drastic change in the technology or a tool
                        then it is definitely (AEM) Adobe Experience Manager. In a very short span of time AEM has
                        caught the attention of many businesses.</p>
                    <p><a routerLink="/blog/five-reasons-why-you-should-outsource-web-app-development">View More</a><span> June, 21 2022</span></p>
                </div>
            </div>
            <div class="col-md-12">
                <div class="blog-post" routerLink="/blog/how-to-get-started-with-adobe-experience-manager-as-a-cloud-service">
                    <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202282919718-975get-started-with-adobe-exp-manager.jpg" alt="How To Get Started With Adobe Experience Manager As A Cloud Service" loading="lazy" />
                    <h5>How To Get Started With Adobe Experience Manager As A Cloud Service</h5>
                    <p class="blog-description">NFTs have been creating their unique identity in the digital world
                        recently. They are opening up the world with a wide range of possibilities for digital
                        marketplaces. </p>
                    <p><a routerLink="/blog/how-to-get-started-with-adobe-experience-manager-as-a-cloud-service">View More</a><span> June, 08 2022</span></p>
                </div>
            </div>
            
            <div class="col-md-12">
                <div class="blog-post" routerLink="/blog/top-five-reasons-to-choose-an-adobe-experience-manager">
                    <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/2022913182334-749top-five-vidhema.jpg" alt="Top 5 Reasons To Choose An Adobe Experience Manager" loading="lazy" />
                    <h5>Top 5 Reasons To Choose An Adobe Experience Manager</h5>
                    <p class="blog-description">Buying and selling is a massive part of our life, and the drastic
                        technological changes have brought a difference in our way of shopping. The eCommerce
                        websites help generate a more customer base for the business, giving them everything they
                        need.</p>
                    <p><a routerLink="/blog/top-five-reasons-to-choose-an-adobe-experience-manager">View More</a><span> May, 24 2022</span></p>
                </div>
            </div>

            <div class="col-md-12">
                <div class="blog-post" routerLink="/blog/how-to-begin-with-nft-marketplace-development">
                    <img src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/202282919847-132begin-with-nft-marketplace.jpg" alt="How To Begin With NFT Marketplace Development" loading="lazy" />
                    <h5>How To Begin With NFT Marketplace Development?</h5>
                    <p class="blog-description">Buying and selling is a massive part of our life, and the drastic
                        technological changes have brought a difference in our way of shopping. The eCommerce
                        websites help generate a more customer base for the business, giving them everything they
                        need.</p>
                    <p><a routerLink="/blog/how-to-begin-with-nft-marketplace-development">View More</a><span> April, 27 2022</span></p>
                </div>
            </div>


        </div>
    </div>
</section>


<section class="last-section" id="contactUs">
    <div class="flex-container">
        <div class="flex-slide singapore">
            <div class="overlay"></div>
            <img id="bgvid" width="100%" height="100%" src="https://vidhema-website.s3.amazonaws.com/Vidhema/VidhemaBlogImages/20228172306-855singapore-backg.jpg"
                class="lasyItem loadVideoPoster" alt="Singapore Location" loading="lazy">

            <div class="overly-txt">
                <div class="title">
                    <h3><span></span>SINGAPORE<i class="fa fa-arrow-right" aria-hidden="true"></i></h3>
                </div>
                <div class="flex-about flex-about-home">
                    <p>
                        68 CIRCULAR ROAD, #02-01,
                        <br>Singapore, 049422
                    </p>
                </div>
            </div>
        </div>
        <div class="flex-slide hyderabad">
            <div class="overlay"></div>
            <img id="bgvid" width="100%" height="100%" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/hyderabad%20(1).jpg?alt=media&token=35db9a52-1e12-4844-9834-6f6b633789a1"
                class="lasyItem loadVideoPoster" alt="Hyderabad Location" loading="lazy" title="hyderabad%20">

            <div class="overly-txt">
                <div class="title">
                    <h3><span></span>HYDERABAD<i class="fa fa-arrow-right" aria-hidden="true"></i></h3>
                </div>
                <div class="flex-about flex-about-home">
                    <p>
                        403, Ashirwad Nilayam,
                        <br>Camelot Layout,
                        <br> Hyderabad 500084
                    </p>

                </div>
            </div>
        </div>
        <div class="flex-slide jaipur">
            <div class="overlay"></div>
            <img id="bgvid" width="100%" height="100%" src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/jpeg-optimizer_jaipur%20(1).jpg?alt=media&token=52594c58-d674-4056-b26a-fb79f9c2336c"
                class="lasyItem loadVideoPoster" alt=" Jaipur Location" loading="lazy" title="jpeg-optimizer_jaipur%20">

            <div class="overly-txt">
                <div class="title">
                    <h3><span></span>JAIPUR<i class="fa fa-arrow-right" aria-hidden="true"></i></h3>
                </div>
                <div class="flex-about flex-about-home">
                    <p>
                        C-5, Shanti Nagar Rd, Shanthi Nagarm,
                        <br>Mansarovar,
                        <br>Jaipur, Rajasthan 302020
                    </p>
                </div>
            </div>
        </div>

    </div>
</section>



<app-quoteform></app-quoteform>

<!-- contact ends -->


